// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
export enum AppPermission {
  CreateCDProject = 'CreateCDProject',
  CreateQCProject = 'CreateQCProject',
  SAMSegment = 'SAMSegment',
  MultiLabelCD = 'MultiLabelCD',
  PreviewFeatures = 'PreviewFeatures',
  ExportVliTai = 'ExportVliTai',
}
